<template>
    <div class="checkbox-container pretty p-default" v-bind:class="{ 'p-round': rounded, 'p-curve': !rounded }">
        <input @change="$emit('change', $event.target.checked)" type="checkbox" :id="id" :checked="value"
               @input="$emit('input', $event.target.checked)">
        <div class="state p-primary">
            <label class="checkbox-label" :for="id">
                    <div class="label-content">
                        {{title}}
                        <span v-if="icon_status" class="icon cb-icon" :class="icon_status" :style="icon_style"></span>
                    </div>
            </label>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Checkbox",
        props: {
            value: {
                type: Boolean,
                default: false
            },
            id: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            icon_status: {
                type: String,
                required: false
            },
            icon_style: {
                type: String,
                required: false
            },
            rounded: {
                type: Boolean,
                required: false
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '~pretty-checkbox/src/scss/variables';

    $pretty--colors:(
            primary:#00b6ed,
            //info:#00bcd4,
            //success:#4caf50,
            //warning:$pretty--color-warning, // default
            //danger:$pretty--color-danger //default
    );

    @import '~pretty-checkbox/src/pretty-checkbox.scss';

    .checkbox-container {
        margin-left: 20px;
        margin-right: 25px;
        font-size: 15px;
    }

    .cb-icon {
        position: absolute;
        right: -20px
    }

    .label-content {
        position: relative;
    }
</style>